import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import formatPhone from '~/utils/format/phone';

const CurrentlyHospitalizedDetail = ({ data }) => {
  const [datum, setDatum] = useState({});

  useEffect(() => {
    if (data && data.length) {
      setDatum(data[0].attributes);
    }
  }, [data]);

  return (
    <>
      <div className="font-weight-bold text-secondary">Admission Date</div>
      <div>{datum.hospadmsntimeTs ? format(datum.hospadmsntimeTs, 'MM/DD/YYYY') : ''}</div>

      <div className="font-weight-bold text-secondary">Reason</div>
      <div>{datum.chiefcomplaint}</div>

      <div className="font-weight-bold text-secondary">Hospital</div>

      <div className="font-weight-bold text-secondary">Location</div>
      <div>
        {datum.location}<br />
        {datum.depaddress}<br />
        {datum.depcity}, {datum.depstate} {datum.depzip}<br />
        <a href={`tel:${datum.phone}`}>{datum.phone ? formatPhone(datum.phone) : ''}</a>
      </div>

      <div className="font-weight-bold text-secondary">Bed</div>
      <div>{datum.bed}</div>

      <div className="font-weight-bold text-secondary">Room</div>
      <div>{datum.room}</div>

      <div>via {datum.sourceDescription}</div>
    </>
  );
};

CurrentlyHospitalizedDetail.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    attributes: PropTypes.shape(),
  })).isRequired,
};

export default CurrentlyHospitalizedDetail;
